/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';

export interface ThreadSummary {
  readonly id: string;
  readonly otherUserId: string;
  readonly otherUserName: string;
  readonly lastMessageBody: string | null;
  readonly lastMessageAt: string;
  readonly unreadCount: number;
}

export interface Message {
  readonly id: string;
  readonly threadId: string;
  readonly senderUserId: string;
  readonly body: string;
  readonly createdAt: string;
}

export interface ThreadDetail {
  readonly id: string;
  readonly otherUserId: string;
  readonly otherUserName: string;
  readonly messages: readonly Message[];
}

export interface Contact {
  readonly userId: string;
  readonly fullName: string;
}

const BASE = '/messages';

export const messagingApi = {
  async listThreads(): Promise<readonly ThreadSummary[]> {
    const { data } = await apiClient.get<readonly ThreadSummary[]>(`${BASE}/threads`);
    return data;
  },
  async contacts(): Promise<readonly Contact[]> {
    const { data } = await apiClient.get<readonly Contact[]>(`${BASE}/contacts`);
    return data;
  },
  async getThread(id: string): Promise<ThreadDetail> {
    const { data } = await apiClient.get<ThreadDetail>(`${BASE}/threads/${id}`);
    return data;
  },
  async startThread(recipientUserId: string): Promise<{ readonly threadId: string }> {
    const { data } = await apiClient.post<{ readonly threadId: string }>(`${BASE}/threads`, {
      recipientUserId,
    });
    return data;
  },
  async send(threadId: string, body: string): Promise<Message> {
    const { data } = await apiClient.post<Message>(`${BASE}/threads/${threadId}/messages`, {
      body,
    });
    return data;
  },
};
